import { render } from "./QuoteIndex.vue?vue&type=template&id=724596dc"
import script from "./QuoteIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Quote/QuoteIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "724596dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('724596dc', __exports__)) {
    api.reload('724596dc', __exports__)
  }
  
  module.hot.accept("./QuoteIndex.vue?vue&type=template&id=724596dc", () => {
    api.rerender('724596dc', render)
  })

}


export default __exports__